export function oldleaderboard(state = {}, action) {
    switch (action.type) {
      case "UPDATE_OLD_LEADERBOARD": {
        const { oldleaderboard } = action;
  
        return Object.assign({}, state, { oldleaderboard});
      }
  
      default:
        return state;
    }
  }


// WEBPACK FOOTER //
// ./src/shells/oldLeaderboard/reducers.js